import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';
import { useSelector } from 'react-redux';

import { ACTIONS_TYPES } from 'redux/helper';
import { ROUTE } from 'constant';
import { service } from 'services';
import CreateForm from './create';

export default () => {
  const [backupUnitsList, setBackupUnits] = useState([]);
  const [deleteId, setDeleteId] = useState('');

  const { [ACTIONS_TYPES.BACKUP_UNIT.GET_ALL]: backupUnits = [], listViewType = '' } = useSelector((e) => e);

  useEffect(() => {
    actions.backupUnits.getAll();
    actions.common.setLayoutTitle({
      layout: { title: 'Backup Units', menu: ROUTE.DASHBOARD.BACKUP_UNIT.key },
    });
  }, []);

  useEffect(() => {
    if (JSON.stringify(backupUnitsList) !== JSON.stringify(backupUnits)) { // TODO fix Max update depth error when remove if
      setBackupUnits([...backupUnits]);
    }
    // eslint-disable-next-line
  }, [backupUnits]);

  const selectToDelete = (id) => {
    setDeleteId(id);
  };

  const onDelete = (confirm) => {
    if (confirm) {
      actions.backupUnits.delete({ id: deleteId });
    }
    setDeleteId('');
  };

  const openHandler = (backupUnitId) => {
    setBackupUnits((s) => ([...s.map((e) => ({ ...e, busy: e.id === backupUnitId }))]));
    service
      .backupUnit
      .getSsoUrl({ backupUnitId })
      .then(({ ssoUrl = '' }) => {
        setBackupUnits((s) => ([...s.map((e) => ({ ...e, busy: false }))]));
        window.open(ssoUrl, 'backupunit', 'location=0,width=1180,height=700');
      });
  };

  return (
    <div style={{ margin: '15px 10px' }} className="screen-common">
      <Shared.widgets.Cards
        title="Backup Units"
        type="common"
        isFilter={false}
        addAction={ACTIONS_TYPES.BACKUP_UNIT.CREATE}
        addRender={<CreateForm />}
        isEmpty={!backupUnitsList.length}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              backupUnitsList.map((unit) => {
                const { properties, id } = unit;
                const { name, email } = properties;

                return ([
                  <Shared.widgets.Icon name="layer-group" />,
                  {
                    value: name,
                    link: id,
                  },
                  email,
                  <Shared.widgets.Icon name="trash" onClick={() => selectToDelete(id)} style={{ color: 'var(--color-danger)' }} />,
                ]);
              })
            }
            onCellClick={(id) => openHandler(id)}
            columns={[
              { name: '' },
              { name: 'Name' },
              { name: 'Email' },
              { name: '' },
            ]}
          />
        ) : (backupUnitsList.map((unit) => {
          const { properties, id, busy = false } = unit;
          const { name, email } = properties;

          return (
            <Shared.widgets.CardBasic
              title={name}
              icon="layer-group"
              iconText="Backup"
              details={email}
              actionButtons={{
                delete: () => selectToDelete(id),
                external: () => openHandler(id),
              }}
              isLoader={busy}
              key={id}
            />
          );
        }))}
      </Shared.widgets.Cards>
      <Shared.dialog.Confirm show={!!deleteId} onClose={onDelete} />
    </div>
  );
};
